<template>
  <el-card :shadow="shadow">
    <h4 slot="header" :class="{ [toSlug(plan.name)]: true }">{{ plan.name }}</h4>
    <span class="from">from</span>
    <span class="price">
      {{ plan.price.month.replace(/([0-9]{2})$/, '') }} {{ $root.currency.symbol }}
    </span>
    <span class="monthly">monthly</span>
    <el-divider />
    <el-select v-model="datacenter" size="mini">
      <el-option
        v-for="(id, name) in datacenters"
        :key="id"
        :label="name"
        :value="id"
      />
    </el-select>
    <el-divider />
    <div class="score">
      <span class="memory">
        <span class="value">{{ plan.memory || plan.memoryMb }}</span>
        {{ plan.memory ? 'GB' : 'MB' }} Memory /
      </span>
      <span class="cpu">
        <span class="value">{{ plan.vcpus }}</span>
        {{ plural('CPU', plan.vcpus )}}
      </span>

      <el-rate
        v-if="false"
        :max="6"
        :value="Math.round(plan.score * 10) / 10"
        size="mini"
        disabled
        text-color="#ff9900"
      />
    </div>

    <el-button type="default" @click.prevent="$emit('select', datacenter)">Configure</el-button>
  </el-card>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    plan: {
      type: Object,
      default: () => ({})
    },
    shadow: {
      type: String,
      default: 'always'
    }
  },
  data () {
    return {
      datacenter: null,
      datacenters: {}
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      this.datacenter = null
      this.datacenters = {}
      for (const name in this.plan.datacenters) {
        this.datacenters[name] = _.sample(Object.values(this.plan.datacenters[name]))
        this.datacenter = this.datacenter || this.datacenters[name]
      }
    }
  },
  watch: {
    plan: {
      handler () {
        this.$nextTick(() => this.load())
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-card {
    text-align: center;
    border-color: $--border-color-base;

    .el-button--info {
      background-color: red;
    }

    &:hover {
      -webkit-box-shadow: $--card-box-shadow-small !important;
      box-shadow: $--card-box-shadow-small !important;
    }
  }
  .el-divider {
    margin: 6px 0;
  }
  .from, .monthly {
    font-size: .8rem;
    font-weight: 500;

    &.monthly {
      font-weight: inherit;
      display: block;
    }
  }
  .price {
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 1em;
    white-space: nowrap;
  }
  .score {
    margin: 10px 0;

    .el-rate {
      margin-top: 5px;
    }
    .memory, .cpu {
      font-size: .8rem;
      font-weight: 500;
      padding-right: 5px;

      .value {
        font-size: 1.6rem;
        font-weight: 500;
        line-height: 1em;
        white-space: nowrap;
      }
      &.memory .value {
        font-size: 1.2rem;
      }
      &.cpu .value {
        color: $--color-primary;
      }
    }
  }
  .el-button--default {
    width: 100%;
  }
</style>
